import React, {useState, useCallback} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {setNewEmail, setNewFirst_Name, setNewLast_Name} from "../../../../Features/Auth/authSlice";
import Avatar from "../../../Components/Avatar";
import FileUploadComponent from "./FileUploadComponent";
import ButtonRow from "./ButtonRow";

const NewDetailsForm = () => {

    const { newEmail, newFirst_Name, newLast_Name} = useSelector((state) => state.auth)
    const {  email, id, first_name, last_name } = useSelector((state) => state.auth.user)

    const inputStyles = "bg-pink-dashboard  focus:outline-none focus:border-pink-icon text-unfocused-text border-white rounded-lg border-3 h-14 px-4 py-2"

    const dispatch = useDispatch();

    const handleChange = useCallback((file) => {
        setFile(file);
    }, []);

    //file state
    const [file, setFile] = useState(null)

    //avoids creating object unless necessary
    let newUserData = {};
    // if (newFirstName || newLastName || newEmail) {
    //     newUserData = {
    //         firstName: newFirstName || firstName,
    //         lastName: newLastName || lastName,
    //         email: newEmail || email,
    //     };
    // }

    if (newFirst_Name || newLast_Name || newEmail) {
        newUserData = {
            first_name: newFirst_Name || first_name,
            last_name: newLast_Name || last_name,
            email: newEmail || email,
        };
    }

    //FileUploader constants
    const fileTypes = ["JPG", "PNG", "GIF", "SVG"];



    return (
        <form className=" form flex flex-col gap-6 sm:gap-12 p-2 pt-6 text-lg  text-white gap-4 w-full xl:w-8/12 ">
            <div className=" nameRow flex flex-col sm:flex-row gap-4 ">

                <div className="flex flex-col w-full sm:w-1/2 gap-2">
                    <label htmlFor={"name"} className={`text-white`}>
                        First Name
                    </label>
                    <input
                        type={"text"}
                        placeholder={
                            useSelector((state) =>
                                state.auth.user.first_name
                                    ? state.auth.user.first_name.charAt(0).toUpperCase() + state.auth.user.first_name.slice(1).toLowerCase()
                                    : "Name"
                            )
                        }
                        id={"name"}
                        value={newFirst_Name}
                        onChange={e => dispatch(setNewFirst_Name(e.target.value))}
                        className={inputStyles}
                    />
                </div>

                <div className="flex flex-col w-full sm:w-1/2  gap-2">
                    <label htmlFor={"surname"} className={`text-white`}>
                        Surname
                    </label>
                    <input
                        type={"text"}
                        placeholder={
                            useSelector((state) =>
                                state.auth.user.last_name
                                    ? state.auth.user.last_name.charAt(0).toUpperCase() + state.auth.user.last_name.slice(1).toLowerCase()
                                    : "Surname"
                            )
                        }
                        id={"surname"}
                        value={newLast_Name}
                        onChange={e => dispatch(setNewLast_Name(e.target.value))}
                        className={inputStyles}
                    />
                </div>
            </div>


            <div className="emailRow flex flex-col gap-2  w-full">
                <label htmlFor={"email"} className={`text-white`}>
                    Email Address
                </label>
                <input
                    type={"email"}
                    placeholder={email}
                    id={"email"}
                    value={newEmail}
                    onChange={e => dispatch(setNewEmail(e.target.value))}
                    className={inputStyles}
                />
            </div>


            <div className="profileRow flex flex-row gap-16 w-full  ">
                <div className="flex flex-col gap-2 w-full ">
                    <label htmlFor={"profileImage"} className={`text-white `}>
                        Profile Picture
                    </label>

                    <div className="flex flex-row h-full w-full p-1 gap-4  justify-between">
                        <Avatar
                            height={" w-12 sm:w-16"}
                            width={" h-12 sm:h-16"}
                            extraStyles={" min-w-12 sm:min-w-16"}
                            type={`user`}

                        />

                        <FileUploadComponent handleChange={handleChange} types={fileTypes} />

                    </div>
                </div>

            </div>
            <ButtonRow newUserData={newUserData} />
        </form>
    );
};

export default NewDetailsForm;